<template>
  <div class="show-visits" v-if="data.visitors" :style="theme=='default'?'margin:10px auto':''">
    <span
      :class="data.border_style"
      :style="{color:data.text_color,background:data.background_color}"
    >
      <svg viewBox="0 0 1024 1024" width="16" height="16">
        <path
          d="M512 140c136.045 0 278.202 99.817 426.47 299.451 31.551 42.482 31.551 100.616 0 143.098l-4.446 5.96C787.359 784.168 646.684 882 512 882c-136.045 0-278.202-99.817-426.47-299.451-31.551-42.482-31.551-100.616 0-143.098l4.446-5.96C236.641 237.832 377.316 140 512 140z m0 239c-72.902 0-132 59.098-132 132s59.098 132 132 132 132-59.098 132-132-59.098-132-132-132z"
          :fill="data.text_color"
          p-id="3378"
        />
      </svg>
      {{ $t("visitors_counter.tip",{count:data.visitors}) }}
    </span>
  </div>
</template>

<script>
export default {
  props: ["data", "theme"]
};
</script>

<style lang="scss" scoped>
.show-visits {
  margin: 10px 0;
  max-width: 400px;
  span {
    padding: 2px 20px;
    border-radius: 30px;
    display: inline-block;
    line-height: 20px;
  }
  .fillet {
    border-radius: 6px !important;
  }
}
</style>